(function () {
  ServiceAvailabilityController.$inject = ["API_URL", "$http", "$routeParams", "$location", "$rootScope", "ShiftService", "$timeout"];

  var moment = require('moment-timezone');

  angular.module('calendarApp').controller('ServiceAvailabilityController', ServiceAvailabilityController);

  function ServiceAvailabilityController(API_URL, $http, $routeParams, $location, $rootScope, ShiftService, $timeout) {
    var serviceID = $routeParams.serviceid,
        date = $routeParams.date,
        endDate = moment(date).add(1, 'days').format('YYYY-MM-DD'),
        throbber = $rootScope.throbber,
        choose = this; // Delete any existing search params

    $location.search({});
    choose.selectedSlots = [];
    choose.date = moment(date).format('ll');
    choose.timeSettings = smooth.timeSettings;
    moment.tz.setDefault(choose.timeSettings.timezone);

    if (!serviceID || !date) {
      $location.path('#/service-calendar');
      return;
    }

    function init() {
      throbber.show();
      $http.get(API_URL + '/api/v1/calendar/timeslots/' + smooth.orgid + '?serviceid=' + serviceID + '&startdate=' + date + '&enddate=' + endDate).then(function (reply) {
        throbber.hide();
        var response = reply.data;

        if (!response.success) {
          throbber.showError(response.msg);
          return;
        }

        if (!response.timeslots || !response.timeslots.length) {
          throbber.showError('Sorry but there is no availability for this day');
          return;
        } // 'timeslots' is a complete misnomer: these are shifts by day
        // (and there should be only one day)


        var day = response.timeslots[0];
        choose.shifts = day.shifts;
        choose.shiftObject = ShiftService.getShiftsByResource(choose.shifts);
        choose.service = choose.shifts.length && choose.shifts[0].service;
      }).catch(function (err) {
        console.error(err.message);
      });
    }

    init();

    choose.continue = function () {
      // At this point we're beginning to build an array of appointments to book
      var newAppointments = [];
      choose.selectedSlots.forEach(function (key) {
        // var key = resourceID + '_' + shiftIndex + '_' + timeslotIndex;
        var elements = key.split('_'),
            resourceID = elements[0],
            shiftIndex = elements[1],
            timeslotIndex = elements[2],
            shift = choose.shiftObject[resourceID].shifts[shiftIndex],
            shiftID = shift._id,
            timeslot = choose.shiftObject[resourceID].shifts[shiftIndex].timeslots[timeslotIndex];
        var appointment = {
          shiftid: shiftID,
          serviceid: timeslot.serviceid,
          start: timeslot.start,
          end: timeslot.end,
          date: shift.date
        };

        if (timeslot.hasresource) {
          appointment.hasresource = true;
          appointment.resourceid = timeslot.resourceid;
        } else {
          appointment.hasresource = false;
        }

        if (shift.isworkshop) {
          appointment.workshopshiftid = shift._id;
        }

        newAppointments.push(appointment);
      });
      $rootScope.throbber.show(); // Now save the appointments tentatively to the server (and to local storage?)

      $http.post(API_URL + '/api/v1/calendar/appointment/reserve', {
        appointments: newAppointments
      }).then(function (reply) {
        $rootScope.throbber.hide();
        var response = reply.data; // Show any overbooked timeslots

        if (response.overbooked) {
          $rootScope.overBooked = [];
          $rootScope.overBooked = response.overbookedappointments; // If some appointments were made and some were not, let the user choose which ones they
          // want to keep

          if (response.appointments.length) {
            // Store timeslots
            var reservedAppointments = response.appointments;
            localStorage.setItem('reserved-appointments', JSON.stringify(reservedAppointments));
            $location.path('/overbooked/chooseslots');
          } else {
            // None of the chosen appointments were allowed.
            choose.noneAllowed = true;
            $timeout(function () {
              choose.noneAllowed = false;
            }, 3000);
          }

          return;
        } // Store tentative appointments in local storage


        if (!response.appointments || !response.appointments.length) {
          return;
        } // Store appointments in all cases


        var reservedAppointments = response.appointments;
        localStorage.setItem('reserved-appointments', JSON.stringify(reservedAppointments)); // If settings allow, go to future slots

        if (smooth.calendarSettings.bookfuturedays) {
          $location.path('/futureslots');
        } else {
          $location.path('/review');
        }
      });
    };

    choose.addTimeslot = function (resourceID, shiftIndex, timeslotIndex) {
      if (choose.shiftObject[resourceID].shifts[shiftIndex].timeslots[timeslotIndex].selected === choose.shiftObject[resourceID].shifts[shiftIndex].bookmulti) {
        return;
      }

      choose.shiftObject[resourceID].shifts[shiftIndex].timeslots[timeslotIndex].selected = choose.shiftObject[resourceID].shifts[shiftIndex].timeslots[timeslotIndex].selected ? choose.shiftObject[resourceID].shifts[shiftIndex].timeslots[timeslotIndex].selected + 1 : 1; // Create a key for the selectedSlots array

      var key = resourceID + '_' + shiftIndex + '_' + timeslotIndex;
      choose.selectedSlots.push(key);
    };

    choose.removeTimeslot = function (resourceID, shiftIndex, timeslotIndex) {
      choose.shiftObject[resourceID].shifts[shiftIndex].timeslots[timeslotIndex].selected--;
      var key = resourceID + '_' + shiftIndex + '_' + timeslotIndex;
      choose.selectedSlots.splice(choose.selectedSlots.indexOf(key), 1);
    }; // Remove selected timeslots - unselect selected timeslots and empty the selected slots


    choose.cancelSelect = function () {
      for (var resourceID in choose.shiftObject) {
        for (var i = 0; i < choose.shiftObject[resourceID].shifts.length; i++) {
          for (var j = 0; j < choose.shiftObject[resourceID].shifts[i].timeslots.length; j++) {
            choose.shiftObject[resourceID].shifts[i].timeslots[j].selected = false;
          }
        }
      }

      choose.selectedSlots = [];
    };

    choose.joinWaitlist = function (timeslot) {
      choose.waitlistModal(timeslot);
    };

    choose.cancel = function () {
      $location.path('/');
    };
  }
})();